<template>
  <div>
    <div>
      <div class="login-register-container">
        <div class="branding">
          <img src="../../../public/FullLogoV3.webp" alt />
          <h3>Pediatric Health Consultants</h3>
        </div>
        <div class="alert">
          <p v-if="feedback" class="red-warning">{{ this.feedback }}</p>
        </div>
        <div class="login-register-wrap">
          <h3 class="title">Create a new account:</h3>
          <form @submit.prevent="register">
            <div class="input-field">
              <div class="label">
                <label for="firstname">Full Name:</label>
              </div>
              <input autocomplete="off" placeholder="Name" v-model="fullname" type="text" id="firstname" />
            </div>
            <div class="input-field">
              <div class="label">
                <label for="email">Email:</label>
              </div>
              <input autocomplete="off" placeholder="Email" v-model="email" type="text" id="email" />
            </div>
            <div class="input-field">
              <div class="label">
                <label for="password">Password:</label>
              </div>
              <input autocomplete="off" placeholder="Password" v-model="password" type="password" id="password" />
            </div>
            <div class="input-field">
              <div class="label">
                <label for="confirmpassword">Confirm Password:</label>
              </div>
              <input
                autocomplete="off"
                placeholder="Confirm Password"
                v-model="confirmPassword"
                type="password"
                id="confirmpassword"
              />
            </div>
            <div class="input-field">
              <div class="label">
                <label for="key">Registration Key</label>
              </div>
              <input
                autocomplete="off"
                placeholder="Enter Registration Key"
                v-model="registrationKey"
                type="text"
                id="key"
              />
            </div>
            <button class="mt-1 btn purple">Register</button>
          </form>
        </div>
        <p class="login-register-switch">
          Already have an account?
          <router-link class="link" to="/login">Login</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/app";
import db from "../firebase/init";

export default {
  name: "Register",
  data() {
    return {
      fullname: null,
      email: null,
      password: null,
      confirmPassword: null,
      feedback: null,
      registrationKey: null,
    };
  },
  methods: {
    register() {
      if (this.fullname && this.email && this.password && this.confirmPassword) {
        if (this.password == this.confirmPassword && this.registrationKey === "SpQKctXTUA") {
          firebase
            .auth()
            .createUserWithEmailAndPassword(this.email, this.password)
            .then((cred) => {
              return db
                .collection("users")
                .doc(cred.user.uid)
                .set({
                  fullname: this.fullname,
                  isAdmin: false,
                  email: this.email,
                  profileImg: null,
                });
            })
            .then(
              () => {
                if (navigator.userAgent.indexOf("Safari") != -1) {
                  this.$router.go({ name: "Dashboard" });
                  window.location.reload();
                } else {
                  this.$router.go({ name: "Dashboard" });
                }
              },
              (err) => {
                this.feedback = err.message;
              }
            );
        } else {
          this.feedback = "Passwords must match.";
        }
      } else {
        this.feedback = "All fields must be completed.";
      }
    },
  },
};
</script>

<style scoped lang="scss">
// all css is in the login component
</style>
